import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
    Toaster,
    useToast,
} from "@postcheesy/ui-lib/molecules";
import React, { useEffect, useState } from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@postcheesy/ui-lib/atoms";
import confirmEmail from "../../api/confirmEmail";
import { useUser } from "../../resources/contexts/UserContext";
import { ROUTES } from "../../resources/constants/routes";

export const EmailConfirmation: React.FC = () => {
    const { refreshUser } = useUser();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { toast } = useToast();
    const [searchParams] = useSearchParams();

    const userId = searchParams.get("userId");
    const confirmationCode = searchParams.get("code");

    useEffect(() => {
        if (userId && confirmationCode) {
            handleConfirmEmail();
        } else {
            toast({
                title: "Erreur",
                description: "Lien de confirmation invalide ou expiré.",
                variant: "destructive",
            });
            navigate(ROUTES.LOGIN);
        }
    }, [userId, confirmationCode, navigate]);

    const handleConfirmEmail = async () => {
        if (!userId || !confirmationCode) {
            return;
        }
        try {
            setLoading(true);
            const confirmed = await confirmEmail(userId, confirmationCode);
            if (confirmed) {
                await refreshUser();
                navigate(ROUTES.VERIFY_PHONE);
            } else {
                navigate(ROUTES.LOGIN);
            }
        } catch (error) {
            // console.error("Error confirming email:", error);
            toast({
                title: "Erreur",
                description: "Échec de la confirmation. Veuillez réessayer.",
                variant: "destructive",
            });
            navigate(ROUTES.LOGIN);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Toaster />
            <Container className="py-6">
                <div className="relative mx-auto grid h-full w-fit grid-cols-1 items-start justify-center">
                    <section className="lg:my-18 container mx-auto my-12 h-fit max-w-xl py-8 md:my-12 2xl:my-32">
                        <Card className="w-full">
                            <CardHeader>
                                <CardTitle className="text-2xl">
                                    {"Vérification de votre email"}
                                </CardTitle>
                                <CardDescription>
                                    {"Nous confirmons votre email, veuillez patienter..."}
                                </CardDescription>
                            </CardHeader>
                            <CardContent className="flex flex-col gap-4 justify-center">
                                {loading ? (
                                    <Button disabled>Confirmation en cours...</Button>
                                ) : (
                                    <Button onClick={handleConfirmEmail}>
                                        Réessayer
                                    </Button>
                                )}
                            </CardContent>
                        </Card>
                    </section>
                </div>
            </Container>
        </Layout>
    );
};